import { Component, Input } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { EntityType, Group, Source } from '../../model/search-constants';
import { SourcePipe } from '../../pipe/source.pipe';
import {
  SearchResultChapterComponent
} from '../search-result-cloud-learning-content/search-result-chapter/search-result-chapter.component';
import {
  SearchResultExerciseComponent
} from '../search-result-cloud-learning-content/search-result-exercise/search-result-exercise.component';
import {
  SearchResultPathComponent
} from '../search-result-cloud-learning-content/search-result-path/search-result-path.component';
import {
  SearchResultWorkbookComponent
} from '../search-result-cloud-learning-content/search-result-workbook/search-result-workbook.component';
import { SearchResultDocComponent } from '../search-result-doc/search-result-doc.component';
import {
  SearchResultDownloadMetaComponent
} from '../search-result-download-meta/search-result-download-meta.component';
import { SearchResultGenericComponent } from '../search-result-generic/search-result-generic.component';
import {
  SearchResultMarketplaceEntryComponent
} from '../search-result-marketplace-entry/search-result-marketplace-entry.component';
import { SearchResultVideoComponent } from '../search-result-video/search-result-video.component';

@Component({
  selector: 'app-search-result-wrapper',
  templateUrl: './search-result-wrapper.component.html',
  styleUrls: [ './search-result-wrapper.component.scss' ],
  imports: [ SearchResultVideoComponent, SearchResultPathComponent, SearchResultChapterComponent, SearchResultExerciseComponent, SearchResultWorkbookComponent, SearchResultDownloadMetaComponent, SearchResultMarketplaceEntryComponent, SearchResultDocComponent, SearchResultGenericComponent, SourcePipe ]
})
export class SearchResultWrapperComponent {
  @Input() results: EverythingSearchResult[];
  Group = Group;
  Source = Source;
  EntityType = EntityType;
}
